import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { canShowBenefits } from '../service/student-profile-view.service';
import InstituteWiseBenefitsLayout from '../../profile-edit/benefits/InstituteWiseBenefitsLayout';

const ProfileBenefits = () => {
    const { state, dispatch } = useContext(SmartContext);
    const navigate = useNavigate();
    const showBenefits = canShowBenefits(state);

    useEffect(() => {
        if (!showBenefits) {
            navigate(`/alumni/${state.data.id}/profile/journey`, { replace: true });
        }
    }, [showBenefits]);

    if (!showBenefits) {
        return null;
    }

    return (
        <div>
            <div className="tab-pane fade active show" id="pills-benefits" role="tabpanel" aria-labelledby="pills-benefits-tab">
                <div className="mt-4">
                    <div className="row g-3">
                       {state.data.userInstitutes.map((institute: any) => (
                            <SmartContext.Provider key={institute.instituteId} value={{ state, dispatch }}>
                                <InstituteWiseBenefitsLayout key={institute.instituteId} instituteId={institute.instituteId} showInstituteName={true} />
                            </SmartContext.Provider>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileBenefits;
